import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const Card = styled.div<{ bg: string }>`
  height: 100%;
  padding: 20px 30px;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.3);
  background-image: ${(props) => `url(${props.bg})`};
  background-position: center;
`;

export const Title = styled.div<{ color: string }>`
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 700;
  ${responsiveFontSize(28, 0.5)};
  text-align: center;
  color: ${(props) => props.color};

  ${mediaQuery('tablet', 'min')} {
    min-height: 75px;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 24px;
  text-align: center;
`;
